import moduleConfig from './location.config'

export default [
  {
    path: moduleConfig.basePath,
    component: () => import('./location.module'),
    children: []
  }
]
